<template>
  <div class="checkout">
    <Top />
    <div class="soso-tab">
      <div class="soso-center">
        <h3 class="soso-title">下单成功</h3>
      </div>
    </div>
    <div class="wrap1200 top20 fix new-order">
    
     <div class="success-box fix">
       <div class="left-column"><img src="../assets/icon-ok.png" alt="下单成功"></div>
       <div class="panel">
         <h4 class="title"><span>订单已经成功提交！</span><br><span>等待卖家对订单进行处理。</span></h4>
         <h5 class="option-title" >您还可以进行以下操作:</h5>
         <div class="option" >
           <router-link :to="`/${$route.params.id}`">继续兑换</router-link>
           <span>&emsp;或&emsp;</span>
           <router-link :to="`/my/order`">订单管理</router-link>
          </div>
         
         <div class="tip"><strong>温馨提示：</strong><br><span>发货之前，若买家需要对订单内容进行调整，请尽早跟卖家沟通协商处理。</span></div>
      
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Top from "../components/top";

export default {
  name: "checkout",
  components: {
    Top
  },
  computed: {
    ...mapGetters(["shopInfo"])
  },
  created() {
    this.$store.dispatch("SHOPINFO", this.$route.params.id)
  }
};
</script>
<style>
.soso-tab {
  width: 100%;
  height: 50px;
  margin: 0 auto;
  padding: 0;
  position: relative;
  border-bottom: 1px solid #ddd;
}
.soso-center {
  width: 1200px;
  line-height: 50px;
  margin: auto;
  text-align: left;
  overflow: hidden;
}
.soso-title {
  width: 200px;
  font-size: 18px;
  display: inline;
  color: #666;
}
.table-material {
  padding: 10px 20px;
  margin: 0 0 30px 0;
  background-color: #fff;
  border: 1px solid #e7e7e7;
}
.table-material .title {
  text-align: left;
}

.new-order .success-box {
  padding: 38px 188px 80px 0;
}
.new-order .success-box .left-column {
  width: 350px;
  margin-right: 50px;
  height: 200px;
  text-align: right;
  float: left;
}
.new-order .success-box .panel {
  float: left;
  width: 612px;
  color: #333;
  text-align: left;
}
.new-order .success-box .panel .title {
  font-size: 16px;
  line-height: 26px;
}
.new-order .success-box .panel .title {
  font-size: 16px;
  line-height: 26px;
}

.new-order .success-box .option-title {
  margin: 32px 0 8px;
}
.new-order .success-box .option {
  padding-bottom: 23px;
  border-bottom: 1px solid #ddd;
}
.new-order .success-box .tip {
  line-height: 22px;
  margin-top: 28px;
  color: #999;
}
.new-order .success-box .option a {
  color: #f60;
}
.new-order .success-box .panel {
  float: left;
  width: 612px;
  color: #333;
}
.new-order .success-box strong {
  color: #e42900;
  font-weight: 700;
}
</style>
